import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';
import { grayDotStyles, lineItemStyles } from '../../common/styles';

export default makeStyles((theme: NextTheme) => ({
  ...lineItemStyles(theme),
  ...grayDotStyles(theme, {
    right: 4,
    marginLeft: 4,
    marginRight: 5,
  }),
  innerLotRelease: {
    display: 'flex',
  },
  innerRelease: {
    flexWrap: 'initial',
  },
  [theme.media.mobile]: {
    innerLotRelease: {
      display: 'block',
    },
    innerRelease: {
      flexWrap: 'wrap',
    },
  },
}));
